import PropTypes from 'prop-types';
import ProgressRing from '@adsk/alloy-react-progress-ring';
import { ComponentProps, FunctionComponent } from 'react';

const POSITIONED_LOADER_STYLE = {
  display: 'flex',
  flex: 1,
  justifyContent: 'center',
  alignItems: 'center',
  padding: 30,
};

export type LoaderProps = ComponentProps<typeof ProgressRing> & {
  noPositioner?: boolean;
};

const Loader: FunctionComponent<LoaderProps> = ({ noPositioner, ...props }) => {
  if (noPositioner) {
    return <ProgressRing {...props} />;
  }
  return (
    <div style={POSITIONED_LOADER_STYLE}>
      <ProgressRing {...props} />
    </div>
  );
};

const { SIZES, VARIANTS } = ProgressRing;

Loader.defaultProps = {
  noPositioner: false,
  size: SIZES.MEDIUM,
};

Loader.propTypes = {
  size: PropTypes.oneOf(Object.values(ProgressRing.SIZES)),
  noPositioner: PropTypes.bool,
};

Loader.displayName = 'Loader';

export default Object.assign(Loader, {
  SIZES,
  VARIANTS,
});
